export default __webpack_public_path__ + "static/media/endorsment1.636ed414.png";